"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const breakpoints = {
    "breakpointSm": "0",
    "breakpointMd": "37.5em",
    "breakpointLg": "64em",
    "breakpointXl": "90em",
    "fluidBreakpointMedium": "60rem",
    "fluidBreakpointXlarge": "144rem"
};
exports.default = breakpoints;
